import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { RentersInsurancePropertySettingsDTO } from '@root/manager-base/data/dtos/properties/renters-insurance-property-settings.dto';

const actions = {
    getRentersInsurancePropertySettings: {
        url: `${BASE_PATH_API}/properties/:propertyId/settings/rentersInsurance`,
        method: 'GET',
        cache: true
    },
    saveRentersInsurancePropertySettings: {
        url: `${BASE_PATH_API}/properties/:propertyId/settings/rentersInsurance`,
        method: 'POST',
        cache: true
    },
    getDefaultUnitBehaviorSetting: {
        url: `${BASE_PATH_API}/properties/:propertyId/settings/defaultUnitSetting`,
        method: 'GET'
    },
    updateDefaultUnitBehaviorSetting: {
        url: `${BASE_PATH_API}/properties/:propertyId/settings/defaultUnitSetting/:defaultUnitBehavior`,
        method: 'PUT'
    },
    deleteDefaultUnitBehaviorSetting: {
        url: `${BASE_PATH_API}/properties/:propertyId/settings/defaultUnitSetting`,
        method: 'DELETE'
    },
};

export interface IPropertySettingsApi {
    getRentersInsurancePropertySettings(params: { propertyId: number }): Promise<RentersInsurancePropertySettingsDTO>;
    saveRentersInsurancePropertySettings(params: { propertyId: number }, settings: RentersInsurancePropertySettingsDTO ): Promise<void>;
    getDefaultUnitBehaviorSetting(params: { propertyId: number }): Promise<number>;
    updateDefaultUnitBehaviorSetting(params: { propertyId: number, defaultUnitBehavior: number }): Promise<void>;
    deleteDefaultUnitBehaviorSetting(params: { propertyId: number }): Promise<void>;
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function PropertySettingsApi() {
    const service = createActions(actions);
    return service;
}
